<template>
  <PanelDrawer v-if="isMobile" v-model="isOpen" v-bind="$props">
    <template #trigger>
      <slot name="trigger" />
    </template>

    <template v-if="$slots.title" #title>
      <slot name="title" />
    </template>

    <slot />

    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </PanelDrawer>

  <PanelDropdown v-else v-model="isOpen" v-bind="$props">
    <template #trigger>
      <slot name="trigger" />
    </template>

    <slot />
  </PanelDropdown>
</template>

<script setup lang="ts">
import { useResponsive } from '@cvo/ui/composables';
import PanelDrawer from '../PanelDrawer/PanelDrawer.vue';
import type { PanelDrawerProps } from '../PanelDrawer/PanelDrawer.model';
import PanelDropdown from '../../molecules/PanelDropdown/PanelDropdown.vue';
import type { PanelDropdownProps } from '../../molecules/PanelDropdown/PanelDropdown.model';

interface ResponsivePanelProps {}
type ChildProps = PanelDrawerProps | PanelDropdownProps;

defineProps<ResponsivePanelProps & ChildProps>();

const isOpen = defineModel<boolean>();

const { isMobile } = useResponsive();
</script>